export default "//cloud.imgsmail.ru/cloud.mail.ru/178578/img/build/editor/doc-edit.png";